"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingHelper = void 0;
var ConcatUrls_1 = require("./Functions/ConcatUrls");
var FlatFilter_1 = require("./Functions/FlatFilter");
var Simplify_1 = require("./Functions/Simplify");
var service;
exports.ReportingHelper = {
    get initialized() {
        return Boolean(service);
    },
    initialize: function (ReportingServiceClass) {
        service = ReportingServiceClass.getInstance();
    },
    pageLoad: function (_a) {
        var suffix = _a.url, prefix = _a.prefix, flowCode = _a.flowCode, lineOfBusiness = _a.lineOfBusiness, maybeDisplayedMessage = _a.displayedMessage, additionalParameters = _a.additionalParameters;
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var url = ConcatUrls_1.concatUrls(prefix, suffix);
        var displayedMessage = FlatFilter_1.flatfilter(maybeDisplayedMessage).join("|");
        // 	console.log(`ReportingHelper: pageLoad ->
        // url : ${url}
        // flowCode : ${flowCode}
        // lineOfBusiness: ${lineOfBusiness}${
        // 		displayedMessage
        // 			? `
        // displayedMessage: ${displayedMessage}`
        // 			: ``
        // 	}`)
        service.firePageLoadEvent(__assign({ url: url, "page.pageInfo.flowCode": flowCode, "page.pageInfo.lineOfBusiness": lineOfBusiness, "page.attributes.displayedMessage": displayedMessage }, additionalParameters));
    },
    linkClick: function (_a) {
        var name = _a.name, _b = _a.position, position = _b === void 0 ? "Body" : _b, suffix = _a.url, prefix = _a.prefix, pageUrl = _a.pageUrl, pagePrefix = _a.pagePrefix, additionalParameters = _a.additionalParameters;
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var url = ConcatUrls_1.concatUrls(prefix, suffix);
        // 	console.log(
        // 		`ReportingHelper: linkClick ->
        // name: ${name}
        // position: ${position}${
        // 			url
        // 				? `
        // url: ${url}`
        // 				: ""
        // 		}`
        // 	)
        if (pageUrl) {
            this.pageLoad({ url: pageUrl, prefix: pagePrefix });
        }
        service.fireLinkClickEvent(__assign({ linkName: name, linkPosition: position, linkDestinationUrl: url }, additionalParameters));
    },
    systemEvent: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var _a = logEventPayload(payload, "systemEvent"), name = _a.name, data = _a.data;
        service.fireSystemEvent(name, data);
    },
    formSubmit: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var _a = logEventPayload(payload, "formSubmit"), name = _a.name, data = _a.data;
        service.fireFormSubmitEvent(name, data);
    },
    formResponse: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var _a = logEventPayload(payload, "formResponse"), name = _a.name, data = _a.data;
        service.fireFormResponseEvent(name, data);
    },
    impression: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var data = Simplify_1.simplify(payload).data;
        // console.log(
        // 	`ReportingHelper: impression ->
        //         data: ${data ? JSON.stringify(data) : ""}
        //     `
        // )
        service.fireImpression(data);
    },
};
/** Function for logging, simplifying, and returning payloads for systemEvent or formSubmit due to their similarity */
function logEventPayload(payload, _eventType) {
    var _a = Simplify_1.simplify(payload), name = _a.name, data = _a.data;
    // 	console.log(
    // 		`ReportingHelper: ${_eventType} ->
    // eventName: ${name}${
    // 			data
    // 				? `
    // additionalData: ${JSON.stringify(data)}`
    // 				: ``
    // 		}`
    // 	)
    return { name: name, data: data };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/helpers/Reporting.js
// module id = 1526
// module chunks = 8